export default [
	{
		id: 'testwiki',
		domain: 'test.wikipedia.org',
		code: 'test',
		family: 'wiki'
	},
	{
		id: 'commonswiki',
		domain: 'commons.wikimedia.org',
		code: 'commons',
		family: 'wiki'
	},
	{
		id: 'metawiki',
		domain: 'meta.wikimedia.org',
		code: 'meta',
		family: 'wiki'
	},
	{
		id: 'wikidatawiki',
		domain: 'wikidata.org',
		code: 'wikidata',
		family: 'wiki'
	},
	{
		id: 'specieswiki',
		domain: 'species.wikimedia.org',
		code: 'species',
		family: 'wiki'
	},
	{
		id: 'sourceswiki',
		domain: 'wikisource.org',
		code: 'sources',
		family: 'wiki'
	},
	{
		id: 'mediawikiwiki',
		domain: 'www.mediawiki.org',
		code: 'mediawiki',
		family: 'wiki'
	}
];



// WEBPACK FOOTER //
// ./src/utils/special-wikis-list.js